import { useDirection, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Card, Heading, Stack, Text, textVariants, breakpoints } from '@etg/wings';
import { Illustration } from '@eti/components';
import { SEAT_MAP_CARD_MAX_WIDTH } from '../constants/modal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const unavailableCardStyles = css`
  place-items: center;

  @media (min-width: ${breakpoints._768}) {
    place-content: center;
  }
`;
const cardStyles = css`
  margin: 0 auto;
  padding: 24px;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    max-width: ${SEAT_MAP_CARD_MAX_WIDTH}px;
  }
`;
const illustrationStyles = css`
  height: 159px;
  margin-bottom: 27px;
  width: 100%;
`;
const UnavailableCard = () => {
  const {
    isRTL
  } = useDirection();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx("div", {
    className: unavailableCardStyles,
    children: /*#__PURE__*/_jsx(Card, {
      className: cardStyles,
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: 24,
        children: [/*#__PURE__*/_jsx(Illustration, {
          className: illustrationStyles,
          id: "saved-trip",
          mirrored: isRTL,
          width: 171
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: 8,
          children: [/*#__PURE__*/_jsx(Heading, {
            level: 2,
            children: t('Product.SeatMap.Segment.Unavailable.Title')
          }), /*#__PURE__*/_jsx(Text, {
            variant: textVariants._14,
            children: t('Product.SeatMap.Segment.Unavailable.Content')
          })]
        })]
      })
    })
  });
};
export default UnavailableCard;
//# sourceMappingURL=UnavailableCard.js.map